"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateRangeWrapper = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _uiKit = require("@cian/ui-kit");
var _classnames = _interopRequireDefault(require("classnames"));
var _locale = require("date-fns/locale");
var _reactDateRange = require("react-date-range");
var styles = _interopRequireWildcard(require("./DateRangeModal.css"));
var React = _interopRequireWildcard(require("react"));
const _excluded = ["hasSelectedRange", "isRedesign"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const HAS_SELECTED_RANGE_CLASSNAME = 'rdr-has-selected-range';
const DateRangeWrapper = _ref => {
  let {
      hasSelectedRange,
      isRedesign
    } = _ref,
    restProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const deviceType = (0, _uiKit.useDeviceType)();
  const isMobile = deviceType === 'phone';
  const className = hasSelectedRange ? HAS_SELECTED_RANGE_CLASSNAME : undefined;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['content-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: (0, _classnames.default)(styles['content'], isRedesign && styles['no-padding'])
  }, /*#__PURE__*/React.createElement(_reactDateRange.DateRange, (0, _extends2.default)({}, restProps, {
    className: className,
    direction: isMobile ? 'vertical' : 'horizontal',
    scroll: isMobile ? {
      enabled: true,
      monthHeight: 280,
      longMonthHeight: 320
    } : undefined,
    months: isMobile ? 12 : 2,
    showPreview: false,
    showMonthArrow: !isMobile,
    showDateDisplay: false,
    showMonthAndYearPickers: false,
    locale: _locale.ru,
    rangeColors: ['#0468FF'],
    weekdayDisplayFormat: "EEEEEE",
    monthDisplayFormat: "LLLL yyyy",
    preventSnapRefocus: true,
    moveRangeOnFirstSelection: false,
    retainEndDateOnFirstSelection: false,
    dragSelectionEnabled: false,
    focusedRange: undefined,
    displayMode: "dateRange",
    calendarFocus: undefined
  }))));
};
exports.DateRangeWrapper = DateRangeWrapper;
DateRangeWrapper.displayName = 'DateRangeWrapper';